import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://api.dbdesign.io' || 'http://localhost:3003';

// reconnectionAttempts: Infinity — never give up.
// socket.io's 'reconnect_failed' event won't fire, so the saga never has
// to choose between "shrug and stop" vs. "keep trying forever". Instead
// it surfaces the current status (CONNECTING / RECONNECTING) to the UI
// and the user sees a SocketStatus indicator until the connection is
// re-established. A future "Reconnect now" UI button can call
// `socket.connect()` to skip the current backoff.
//
// reconnectionDelayMax bumped to 30s (was 5s) so backed-off attempts
// don't hammer a struggling server.
//
// randomizationFactor: 0.5 jitter so concurrent tabs / clients don't
// stampede on reconnect.
const SHARED_OPTIONS = {
    path: "/mux/",
    withCredentials: true,
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 30_000,
    randomizationFactor: 0.5,
    timeout: 20_000,
};

// export const notificationsSocket = io(`${SOCKET_URL}/notifications`, SHARED_OPTIONS);
export const collaborationSocket = io(`${SOCKET_URL}/collaboration`, SHARED_OPTIONS);

export const NAMESPACES = {
    NOTIFICATIONS: 'notifications',
    COLLABORATION: 'collaboration',
};

export function getSocketByNamespace(ns) {
    // if (ns === NAMESPACES.NOTIFICATIONS) return notificationsSocket;
    if (ns === NAMESPACES.COLLABORATION) return collaborationSocket;
    throw new Error(`Unknown namespace: ${ns}`);
}
